module.exports = __webpack_public_path__ + "static/hpe_pri_grn_pos_rgb-bdb0f41d505a6f92377855abee1f1256.png";